export default __webpack_public_path__ + "static/media/logoMb.097ac9e5.png";